import React from "react";
// used for making the prop types of this component
import PropTypes from "prop-types";

import { Button } from "components";

import defaultImage from "assets/img/image_placeholder.jpg";
import defaultAvatar from "assets/img/placeholder.jpg";
import imageCompression from 'browser-image-compression';
import { Card, CardBody, CardHeader, CardFooter } from "reactstrap";

class ImageUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: this.props.existingImage ? true : null,
      imagePreviewUrl:
        this.props.existingImage ||
        (this.props.avatar ? defaultAvatar : defaultImage),
      uploadingImage: false,
      imageIdentifier: this.props.imageIdentifier
    };
    this.handleImageChange = this.handleImageChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.updateImagePreview = this.updateImagePreview.bind(this);
    this.updateImageFile = this.updateImageFile.bind(this);
    this.imageUploadStatus = this.imageUploadStatus.bind(this);
  }
  updateImagePreview(preview) {
    this.setState({
      imagePreviewUrl: preview
    });
  }
  updateImageFile(image) {
    this.setState({
      file: image
    });
  }
  imageUploadStatus(status) {
    // console.log("Estado subida");
    // console.log(status);
    if (status < 100 && !this.state.uploadingImage) {
      this.setState({ uploadingImage: true });
    }
    if (status === 100) {
      this.setState({ uploadingImage: false });
    }
  }
  handleImageChange(event) {
    event.preventDefault();
    this.setState({ uploadingImage: true });
    let files = event.target.files;
    if (files.length > 1) {
      // console.log("Iniciando subida múltiple");
      let images = [];
      for (let i = 0; i < files.length; i++) {
        let file = files[i];
        let reader = new FileReader();
        reader.onloadend = () => {
          // console.log('originalFile instanceof Blob', file instanceof Blob); // true
          // console.log(`originalFile size ${file.size / 1024 / 1024} MB`);
         
          var options = {
            maxSizeMB: 0.2,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
            onProgress: this.imageUploadStatus
          };
          imageCompression(file, options)
            .then(compressedFile => {
              // console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
              // console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB
         
              // return uploadToServer(compressedFile); // write your own logic 
              var reader = new FileReader();
              this.updateImageFile(compressedFile);
              reader.readAsDataURL(compressedFile);
              reader.onloadend = (function() {
                  // var base64data = reader.result;
                  this.updateImagePreview(reader.result);
                  // images.push(reader.result);
                  images.push(this.props.getImage(reader.result, null, true));
                  // console.log("images.length", images.length);
                  if (images.length === files.length) {
                    // console.log("Y ahora se mandarían todas");
                    // console.log("images", images);
                    this.props.getImage(null, null, null, images);
                  }
              }).bind(this);
              // console.log("Image uploaded");
              // console.log("compressedFile");
              // console.log(compressedFile);
              // console.log("reader.result");
              // console.log(reader.result);
            })
            .catch(function (error) {
              console.log(error.message);
            });
        };
        reader.readAsDataURL(file);
      }
      // this.props.getImage(null, null, JSON.parse(JSON.stringify(images)));
    } else {
      let reader = new FileReader();
      let file = files[0];
      reader.onloadend = () => {
        // console.log('originalFile instanceof Blob', file instanceof Blob); // true
        // console.log(`originalFile size ${file.size / 1024 / 1024} MB`);
       
        var options = {
          maxSizeMB: 0.2,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
          onProgress: this.imageUploadStatus
        };
        imageCompression(file, options)
          .then(compressedFile => {
            // console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
            // console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB
       
            // return uploadToServer(compressedFile); // write your own logic 
            var reader = new FileReader();
            this.updateImageFile(compressedFile);
            reader.readAsDataURL(compressedFile);
            reader.onloadend = (function() {
                // var base64data = reader.result;
                this.updateImagePreview(reader.result);
                this.props.getImage(reader.result, this.state.imageIdentifier);
            }).bind(this);
            // console.log("Image uploaded");
            // console.log("compressedFile");
            // console.log(compressedFile);
            // console.log("reader.result");
            // console.log(reader.result);
          })
          .catch(function (error) {
            console.log(error.message);
          });
      };
      reader.readAsDataURL(file);
    }
  }
  handleSubmit(e) {
    e.preventDefault();
    // this.state.file is the file/image uploaded
    // in this function you can save the image (this.state.file) on form submit
    // you have to call it yourself
  }
  handleClick() {
    this.refs.fileInput.click();
  }
  handleRemove() {
    this.setState({
      file: null,
      imagePreviewUrl: this.props.avatar ? defaultAvatar : defaultImage
    });
    this.refs.fileInput.value = null;
  }
  render() {
    return (
      <div className="fileinput text-center">
        <input type="file" onChange={this.handleImageChange} ref="fileInput" multiple/>
        <div className={"thumbnail" + (this.props.avatar ? " img-circle" : "")}>
          {this.state.uploadingImage ? (
            <Card color="warning" style={{ margin: 0 }}>
              <CardHeader></CardHeader>
              <CardBody className="text-center">
                <div>
                  <div className="text-center">
                    <br />
                    <h5><i className="now-ui-icons arrows-1_refresh-69 spin" /> Subiendo</h5>
                  </div>
                </div>
              </CardBody>
              <CardFooter></CardFooter>
            </Card>
          ) : (
            <img src={this.state.imagePreviewUrl} alt="..." />
          )}
        </div>
        <div>
          {this.state.file === null ? (
            <Button color="primary" round onClick={() => this.handleClick()}>
              {this.props.avatar ? "Añadir foto" : "Seleccionar imagen"}
            </Button>
          ) : (
            !this.props.hideButtons && (
              <span>
                {!this.props.hideChangeButton && <Button color="info" round onClick={() => this.handleClick()}>
                  {this.props.changeButtonText || "Cambiar"}
                </Button>}
                {this.props.avatar ? <br /> : null}
                {!this.props.hideDeleteButton && <Button color="danger" round onClick={() => this.handleRemove()}>
                  <i className="fa fa-times" /> Eliminar
                </Button>}
              </span>)
          )}
        </div>
      </div>
    );
  }
}

ImageUpload.propTypes = {
  avatar: PropTypes.bool,
  existingImage: PropTypes.string,
  getImage: PropTypes.func,
  imageIdentifier: PropTypes.string,
  hideButtons: PropTypes.bool
};

export default ImageUpload;



// WEBPACK FOOTER //
// ./src/components/CustomUpload/ImageUpload.jsx